import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { I18nService } from './infra/translations/i18n.service';
import { GetParametrosLocacaoRepository } from '@data/repository/home/getParametrosLocacao.respository';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLoading!: boolean;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private getParametrosLocacaoRepository: GetParametrosLocacaoRepository,
    private i18nService: I18nService
  ) { }

  ngOnInit() {
    this.getParametrosLocacao();
    // Setup translations
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

    const onNavigationEnd = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );

    merge(this.translateService.onLangChange, onNavigationEnd)
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });
  }

  getParametrosLocacao() {
    this.isLoading = true;
    this.getParametrosLocacaoRepository.get().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response) {
          const maximoHoraExtra = response?.Data?.find((param: any) => param.Parametro == "MaximoHorasExtras")
          const maximoHoraExtraCortesia = response?.Data?.find((param: any) => param.Parametro == "MaximoHorasExtrasCortesia")
          if (maximoHoraExtra) {
            sessionStorage.setItem('maximoHoraExtra', maximoHoraExtra?.Valor);
          } else {
            sessionStorage.setItem('maximoHoraExtra', '0');
          }
          if (maximoHoraExtraCortesia) {
            sessionStorage.setItem('maximoHoraExtraCortesia', maximoHoraExtraCortesia?.Valor);
          } else {
            sessionStorage.setItem('maximoHoraExtraCortesia', '0');
          }
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Erro ao obter parâmetros de locação:', error);
      }
    });
  }
}
